import React from 'react';
import Card from '../ui/Card';
import Button from '../ui/Button';
import { typography } from '../../design-system/tokens';

const LOW_MEMBER_THRESHOLD = 3;

export default function GroupInviteBanner({ memberCount = 0, onInvite }) {
  if (memberCount >= LOW_MEMBER_THRESHOLD) return null;

  return (
    <Card
      variant="admin"
      className="p-4 border-violet-500/30 bg-gradient-to-br from-violet-500/10 via-black/40 to-black/60"
    >
      <p className={`${typography.microWide} text-violet-300 mb-1`}>Grow your league</p>
      <p className="text-sm font-bold text-gray-200 mb-1">
        {memberCount <= 1
          ? 'Leagues are better with rivals — invite someone to post locks.'
          : 'A few more members keeps the action going.'}
      </p>
      <p className="text-xs text-gray-500 font-medium mb-3">
        {memberCount} member{memberCount === 1 ? '' : 's'} so far. Invite friends who play the same sport.
      </p>
      <Button type="button" variant="admin" size="sm" onClick={onInvite}>
        Invite another member
      </Button>
    </Card>
  );
}
